export default {
  'en-US': {
    orderStatusDetails: {
      processing: {
        picked: 'Order has been picked',
        packed: 'Order has been packed',
        labeled: 'Order has been labeled'
      },
      completed: {
        processing: 'Order is waiting for carrier pickup',
        inTransit: 'Order is in transit',
        outForDelivery: 'Order is out of delivery',
        delivered: 'Order has been delivered',
        deliveryException: 'Order could not be delivered'
      },
      exception: {
        bundle: 'Order contains bundled product(s)',
        mergedItem: 'Order contains merge product(s)',
        inactiveSku: 'Order contains inactive product(s)',
        outOfStock: 'Order contains product(s) that are out of stock',
        unknownSku: 'Unknown SKU(s)',
        internalTransferInProgress: 'Order contains product(s) that are current being transferred internally between FCs',
        binTransferInProgress: 'Order contains product(s) that are current being transferred internally within an FC',
        inventoryInNonPickableLocation: 'Order contains product(s) that are in a non-pickable location',
        inventoryPartiallyCommitted: 'Order is Partially Committed and is missing inventory for the following product(s)'
      },
      onHold: {
        paymentDeclined: 'Payment has been declined',
        invalidAddress: 'Invalid address',
        reserveDateNotMet: 'Reserve date not met',
        missingTariffInformation: 'Missing product value, tariff code, product description and/or product weight',
        manual: 'Manual',
        packagePreferences: 'No packaging preferences set for the following product(s) - ',
        autoProcessingPause: 'Automatic processing pause',
        pickInProgress: 'Pick in progress',
        internationalHazmat: 'International Hazmat'
      }
    }
  },
  'ja-JP': {
    orderStatusDetails: {
      processing: {
        Picked: 'Order has been picked',
        Packed: 'Order has been packed',
        Labeled: 'Order has been labeled'
      },
      completed: {
        Processing: 'Completed',
        InTransit: 'Order is in transit',
        OutForDelivery: 'Order is out of delivery',
        Delivered: 'Order has been delivered',
        DeliveryException: 'Order could not be delivered'
      },
      exception: {
        Bundle: 'Order contains bundled product(s)',
        MergedItem: 'Order contains merge product(s)',
        InactiveSku: 'Order contains inactive product(s)',
        OutOfStock: 'Order contains product(s) that are out of stock',
        UnknownSku: 'Unknown SKU(s)',
        InternalTransferInProgress: 'Order contains product(s) that are current being transferred internally between FCs',
        BinTransferInProgress: 'Order contains product(s) that are current being transferred internally within an FC',
        InventoryInNonPickableLocation: 'Order contains product(s) that are in a non-pickable location',
        InventoryPartiallyCommitted: 'Order is Partially Committed and is missing inventory for the following product(s)'
      },
      onHold: {
        PaymentDeclined: 'Payment has been declined',
        InvalidAddress: 'Invalid address',
        ReserveDateNotMet: 'Reserve date not met',
        MissingTariffInformation: 'Missing customs info',
        Manual: 'Manual',
        packagePreferences: 'No packaging preferences set for the following product(s) - ',
        autoProcessingPause: 'Automatic processing pause',
        pickInProgress: 'Pick in progress',
        InternationalHazmat: 'International Hazmat'
      }
    }
  }
}
